import * as React from 'react';
import { connect } from "react-redux";
import {AppActions, IState} from '../../types/types'
import {  createTheme,  responsiveFontSizes,  ThemeProvider} from '@mui/material/styles';
import { lime, purple } from '@mui/material/colors';
import { setContainersVisible } from '../../actions/folderViewActions';
import { ThunkDispatch } from 'redux-thunk';
import { currPathValue, docPathValue } from '../../types/enums';
import CommentList from '../commentSheet/commentList';
import DocumentList from '../TosTransfer/documentList';
import RevisionList from '../massUpdateRevisions/revisionList';
import { useLocation } from "react-router-dom";
import PdfFileList from '../pdfConvert/fileList';
import CircularProgress from '@mui/material/CircularProgress';

let theme = createTheme({
  palette: {
    primary: lime,
    secondary: purple,
  },
});
theme = responsiveFontSizes(theme);

interface AppProps {
  setContainersVisible: (currentPath: currPathValue, requestId: string) => void;
  isVisible: boolean;
  isLoading: boolean;
  hasAccess: boolean;
  hasErrored: boolean;  
  docPath: docPathValue;
}

const FrontPageContainer = (props:AppProps)=> {
    const location = useLocation();

    React.useEffect(() => {
      console.log("FrontPageContainer useEffect", location.pathname);
      const params = new URLSearchParams(window.location.search);
      let requestId="";
      if(params.has('requestId')) requestId = params.get('requestId')!;
      props.setContainersVisible(location.pathname as currPathValue, requestId);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // ✅ run once 

    if (props.isVisible===false) {
        return <div className="not-visible"></div>;
      }

    if (props.hasAccess===false) {
      return <div className="error">
              <p>Your user has no access to this extention</p>
          </div>;
    }
    
    if (props.hasErrored) {
        return <div className="error">
                    <p>Sorry! Error occured:</p>
                </div>;
    }

    if (props.isLoading) {
      console.log("Loading");
      return  <div className="material-table-outer-container">
                <CircularProgress />
              </div>;
    } 

    return (
        <ThemeProvider theme={theme}>
            {((location.pathname as currPathValue).toLowerCase() === currPathValue.massUpdateRevisions.toLowerCase()) && <RevisionList/>}
            {((location.pathname as currPathValue).toLowerCase() === currPathValue.commentSheet.toLowerCase()) && <CommentList/>}
            {((location.pathname as currPathValue).toLowerCase() === currPathValue.pdfConvert.toLowerCase()) && <PdfFileList/>}
            {((location.pathname as currPathValue).toLowerCase() === currPathValue.transferToProteknisk.toLowerCase()) && <DocumentList docPath={props.docPath}/>}
            {((location.pathname as currPathValue).toLowerCase() === currPathValue.transferHistoriskToFdv.toLowerCase()) && <DocumentList docPath={props.docPath}/>}
            {((location.pathname as currPathValue).toLowerCase() === currPathValue.transferFromProtekniskToTos.toLowerCase()) && <DocumentList docPath={props.docPath}/>}
        </ThemeProvider>
        );
    }

const mapStateToProps = (state:IState) => { return {
  isVisible: state.uiState.MAIN_CONTAINER_IsVisible,
  isLoading: state.uiState.MAIN_CONTAINER_IsLoading,
  hasAccess: state.uiState.MAIN_CONTAINER_HasAccess,
  hasErrored: state.uiState.MAIN_CONTAINER_HasErrored,
}}

const mapDispatchToProps = (dispatch:ThunkDispatch<IState,undefined,AppActions>)  => ( {
  setContainersVisible: (currentPath: currPathValue, requestId: string) => dispatch(setContainersVisible(currentPath, requestId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FrontPageContainer);



